import { render, staticRenderFns } from "./BaseNavigationBar.vue?vue&type=template&id=0f1abeb4&scoped=true"
import script from "./BaseNavigationBar.vue?vue&type=script&lang=js"
export * from "./BaseNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./BaseNavigationBar.vue?vue&type=style&index=0&id=0f1abeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1abeb4",
  null
  
)

export default component.exports